module.exports = __webpack_public_path__ + "img/paper-4.b5a10e7e.png";